<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-02 21:22:28
 * @Description: 排名弹框
 * @FilePath: \sheyang\src\module\rankModal\index.vue
-->
<template>
  <div class="sation-rank-modal">
    <pub-main-modal
      :visible="visible"
      :nobg="true"
      :isRank="true"
      @change-visible="onChangeVisible"
    >
      <template slot="content">
        <div class="rank-modal-content flex-col">
          <div class="section_6 flex-row justify-between">
            <span class="text_1">充电场站排名</span>
            <div class="rank-header flex-row">
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="@/assets/images/searchIcon.png"
                alt=""
              />
              <el-input
                class="custom-search"
                v-model="serchValue"
                placeholder="请输入场站名称"
                @blur="searchStation"
                @keyup.enter.native="searchStation"
              />
              <!-- <span class="text_2">搜索场站名称</span> -->
            </div>
          </div>

          <div class="label-wrapper flex-row">
            <span class="text" style="margin-left: 34px">排名</span>
            <span class="text" style="margin-left: 38px; width: 200px">场站名称</span>
            <span class="text" style="width: 150px">累计充电量</span>
            <span class="text" style="width: 140px">今日电量</span>
            <span class="text" style="width: 140px">昨日电量</span>
            <span class="text" style="width: 300px">终端数（充电/离线/故障）</span>
          </div>
          <div class="table-content">
            <div
              class="item-content flex-row"
              v-for="(item, index) in noEmpayData"
              :key="index"
              @click="hanldeVisible(item)"
            >
              <img
                v-if="index === 0"
                class="top-image"
                referrerpolicy="no-referrer"
                src="@/assets/images/top1.png"
                alt=""
              />
              <img
                v-else-if="index === 1"
                class="top-image"
                referrerpolicy="no-referrer"
                src="@/assets/images/top2.png"
                alt=""
              />
              <img
                v-else-if="index === 2"
                class="top-image"
                referrerpolicy="no-referrer"
                src="@/assets/images/top3.png"
                alt=""
              />
              <div v-if="index > 2" class="other-rank-index flex-col">
                <span class="text_28">{{ index + 1 }}</span>
              </div>
              <!-- <span class="item-text">{{ item.stationName }}</span> -->
              <span class="item-text" style="margin-left: 38px; width: 200px">{{
                item.stationName
              }}</span>
              <span class="item-text" style="width: 150px">{{ item.sumPower | toNumber }}</span>
              <span class="item-text" style="width: 140px">{{ item.todayPower | toNumber }}</span>
              <span class="item-text" style="width: 140px">{{
                item.yesterdayPower | toNumber
              }}</span>
              <span class="item-text" style="width: 300px">{{
                `${item.connectorCnt}（${item.chargingCnt}/${item.offlineCnt}/${item.faultCnt}）`
              }}</span>
            </div>
          </div>
        </div>
      </template>
    </pub-main-modal>
    <station-charge-modal :visible="openStationDialog" />
  </div>
</template>

<script>
import * as TYPE from "@/store/const";
import { mapMutations, mapState } from "vuex";
// 一级公共弹框
import pubMainModal from "@/components/pubMainModal/index.vue";
// 单场站充电弹框
import stationChargeModal from "@/module/overview/stationChargeModal/index.vue";

export default {
  name: "sationRankModal",
  components: {
    pubMainModal,
    stationChargeModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rankData: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    toNumber(val) {
      return val ? Number(val).toFixed(0) : "0";
    },
  },
  computed: {
    ...mapState({
      openStationDialog: (state) => state.global.openStationDialog,
    }),
  },
  watch: {
    rankData(val) {
      // console.log('---排行数据', val);
      // // this.stationStatistics.rankingType = val;
      // 删除 rankData 中的空对象
      this.noEmpayData = val.filter((item) => Object.keys(item).length > 0);
    },
  },
  data() {
    return {
      serchValue: "",
      noEmpayData: [],
      openStationDialog1: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations([TYPE.STATION_MODAL_CHANGE, "getStationId", "getCurrentStation"]),
    onChangeVisible() {
      this.$emit("onChangeVisible", false);
    },
    // 父组件调用子组件方法
    hanldeVisible(item) {
      // 存储 currentStationId
      this.getCurrentStation(item.stubGroupId);
      this.onChangeVisible1(true);
    },
    // 搜索场站 按照场站名称搜索 前端筛选 noEmpayData
    searchStation() {
      if (this.serchValue) {
        this.noEmpayData = this.noEmpayData.filter((item) =>
          item.stationName.includes(this.serchValue)
        );
      } else {
        this.noEmpayData = this.rankData.filter((item) => Object.keys(item).length > 0);
      }
    },
    onChangeVisible1(flag) {
      this[TYPE.STATION_MODAL_CHANGE](flag);
    },
  },
};
</script>

<style lang="less" scoped>
.sation-rank-modal {
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-between {
    justify-content: space-between;
  }

  .table-content {
    height: 700px;
    overflow: hidden;
    overflow-y: auto;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .rank-modal-content {
    box-shadow: inset 0px 0px 35px 6px rgba(21, 178, 255, 0.31);
    background-image: url(~@/assets/images/rankModalBg.png);
    position: relative;
    width: 1189px;
    background-size: cover;
    height: 863px;
    border: 3px solid;
    margin: 14px 0 89px 369px;
    .section_6 {
      width: 1108px;
      height: 39px;
      margin: 12px 0 0 38px;
      .text_1 {
        text-shadow: 0px 0px 8px rgba(0, 178, 255, 1);
        width: 144px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
      }
      .rank-header {
        border-radius: 18px;
        width: 300px;
        height: 36px;
        border: 2px solid rgba(255, 255, 255, 0.5);
        margin-top: 3px;
        .thumbnail_1 {
          width: 17px;
          height: 17px;
          margin: 10px 0 0 18px;
        }
        .text_2 {
          width: 95px;
          height: 22px;
          overflow-wrap: break-word;
          color: rgba(255, 255, 255, 1);
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Regular;
          font-weight: NaN;
          text-align: left;
          white-space: nowrap;
          line-height: 22px;
          margin: 7px 159px 0 11px;
        }

        .custom-search {
          width: 200px;
          height: 30px;
          ::v-deep .el-input__inner {
            background-color: transparent;
            border: none;
            color: #fff;
            font-size: 16px;
            font-family: AlibabaPuHuiTi-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 22px;
          }
        }
      }
    }
    .label-wrapper {
      box-shadow: inset 0px 0px 11px 0px rgba(79, 179, 255, 0.54);
      background-color: rgba(143, 204, 255, 0.09);
      border-radius: 8px;
      width: 1108px;
      height: 60px;
      border: 0.5px solid;
      margin: 27px 0 0 38px;
      .text {
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        margin-left: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin-top: 14px;
      }
      .text_3 {
        width: 48px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin: 14px 0 0 34px;
      }
      .text_4 {
        width: 95px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin: 14px 0 0 38px;
      }
      .text_5 {
        width: 119px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin: 14px 0 0 385px;
      }
      .text_6 {
        width: 142px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin: 14px 80px 0 167px;
      }
    }
    .item-content {
      background-color: rgba(64, 181, 255, 0.15);
      border-radius: 8px;
      width: 1108px;
      height: 60px;
      margin: 10px 0 0 38px;
      .top-image {
        width: 56px;
        height: 35px;
        margin: 13px 0 0 30px;
      }
      .item-text {
        overflow: hidden;
        color: rgba(255, 255, 255, 0.9);
        font-size: 24px;
        text-overflow: ellipsis;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin: 14px 0 0 16px;
      }
      .text_7 {
        width: 142px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 162, 0, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin: 14px 0 0 34px;
      }
      .text_8 {
        width: 124px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 0.9);
        font-size: 28px;
        font-family: D-DINExp-Bold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin: 15px 0 0 338px;
      }
      .text_9 {
        width: 60px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 0.9);
        font-size: 28px;
        font-family: D-DINExp-Bold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin: 15px 162px 0 162px;
      }
    }

    .other-rank-index {
      height: 39px;
      border: 2px solid;
      width: 60px;
      margin: 11px 0 0 28px;
      .text_28 {
        width: 14px;
        height: 32px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        font-family: D-DINExp-Bold;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 32px;
        margin: 3px 0 0 23px;
      }
    }

    .image_4 {
      width: 363px;
      height: 6px;
      margin: 15px 0 0 398px;
    }
    .image_5 {
      position: absolute;
      left: 1179px;
      top: 494px;
      width: 7px;
      height: 240px;
    }
  }
}
</style>
